import { useQuery } from "react-query";
import endpoints from "./EndPoints"
import { getAllContractType } from "./Services";



export const useGetAllContractType = () => {
  return useQuery([endpoints.getAllContractType], () => getAllContractType(), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};


